var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 820",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 476.406C0 523.31 19.0123 565.762 49.75 596.5C80.4876 627.238 122.94 646.25 169.844 646.25L512 646.25L854.156 646.25C901.06 646.25 943.512 627.238 974.25 596.5C1004.99 565.762 1024 523.31 1024 476.406L1024 0L914 0L914 476.406C914 492.594 907.692 507.495 896.469 518.719C885.245 529.943 870.344 536.25 854.156 536.25L169.844 536.25C153.656 536.25 138.755 529.943 127.531 518.719C116.307 507.495 110 492.594 110 476.406L110 0",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 710L27 765L27 820L512 820L997 820L997 765L997 710L512 710L27 710Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.0d680db9423a9e924b444a93f3807e2a.svg";
export { ForwardRef as ReactComponent };